import React, { useState, useRef, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Button, Tab, Tabs, Modal, Image, Spinner } from "react-bootstrap";
import { Form } from "@unform/web";
import { SubmitHandler, FormHandles } from "@unform/core";
import * as Yup from "yup";

import getValidationErrors from "../../../../helpers/getValidateErrors";
import { base64toBlob } from "../../../../helpers/utils";
import { ToastContext } from "../../../../contexts/toast/toastContext";
import TabGeral from "./TabGeral";
import TabOutrasCaracteristicas from "./TabOutrasCaracteristicas";
import TabImagensFichaTecnica from "./TabImagensFichaTecnica";
import TabProdutoCor from "./TabProdutoCor";
import {
  IFormVidro,
  IOutrasCaracteristicas,
} from "../../../../common/interfaces/produtos.interfaces";
import api from "../../../../services/api";
import { ToastErrorContext } from "../../../../contexts/toast/toastErrorContext";
import history from "../../../../helpers/history";
import Placeholder from "../../../../assets/imgs/img-placeholder.png";
import { toast } from "react-toastify";
import { getSingleErrorMessage } from "../../../../helpers/getSingleErrorMessage";
import BackButton from "../../../../components/ButtonBack";

interface IVidro {
  tipoProduto: any;
}

const Vidros: React.FC<IVidro> = (props) => {
  // URL Params
  const { pId }: any = useParams();

  // Fields
  const novo = pId == 0;
  const baseUrlImagem = `${process.env.REACT_APP_API}figurasicones/vidros/figuras/`;

  // Refs
  const formRefVidros = useRef<FormHandles>(null);

  // Context
  const toastContext = useContext(ToastContext);
  const toastError = useContext(ToastErrorContext);

  //States
  const emValidacao = useRef("");
  const [loadingSave, setLoadingSave] = useState(false);
  const [show, setShow] = useState(false);
  const [outrasCaracteristica, setOutrasCaracteristica] = useState<
    IOutrasCaracteristicas[]
  >([]);
  const [figuraIcone, setFiguraIcone] = useState<any>({});
  const [selectValues, setSelectValues] = useState<any>({});
  const [logoLinha, setLogoLinha] = useState<any>(null);
  const [selectedTab, setSelectedTab] = useState("");
  const [corVidros, setCorVidro] = useState([]);
  const [reloadCor, setReloadCor] = useState(false);
  const [loadingValues, setLoadingValues] = useState(false);
  const [reload, setReload] = useState(false);
  const [material, setMaterial] = useState<any>(null);

  // Effects
  useEffect(() => {
    (async () => {
      if (props.tipoProduto.toUpperCase() == "VIDRO") {
        if (!novo) {
          const { data } = await api.get(`vidro/${pId}`);
          setMaterial(data);

          emValidacao.current =
            data?.situacao.label == "Em Edição" ||
            data?.situacao.label == "Em Homologação"
              ? "validacao/"
              : "";
        }
      }
    })();
  }, [props.tipoProduto, reload]);

  useEffect(() => {
    (async () => {
      if (props.tipoProduto.toUpperCase() == "VIDRO") {
        setLoadingValues(true);

        const referencia = await api.get(
          "geral/selecaoReferenciaMaterial/VIDRO"
        );
        const tipoVidro = await api.get("geral/selecaoTipoVidro");

        setSelectValues({
          referencia: referencia.data,
          tipoVidro: tipoVidro.data,
          formRef: formRefVidros,
        });

        setLoadingValues(false);
      }
    })();
  }, [props.tipoProduto]);

  useEffect(() => {
    material && formRefVidros.current?.setData(material);
  }, [material]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get(`vidro/selectCorVidro/${pId}`);
      setCorVidro(data);
    })();
  }, [material, reloadCor]);

  // Handles
  const handleClose = () => setShow(false);

  const handleNew = () => {
    setShow(true);
  };

  const handleSubmit: SubmitHandler<IFormVidro> = async (vidro) => {
    try {
      formRefVidros.current?.setErrors({});

      const message = "Campo obrigatório";
      const schema = Yup.object().shape({
        status: Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable()
          .required(message),
        situacao: Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable()
          .required(message),
        codigo: Yup.string()
          .required(message)
          .max(20, "O código só pode ter no máximo 20 caracteres."),
        codigoInterno: Yup.string().max(
          20,
          "O código interno só pode ter no máximo 20 caracteres."
        ),
        referencia: Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable()
          .required(message),
        linha: Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable()
          .required(message),
        descricao: Yup.string()
          .required(message)
          .max(100, "A descrição só pode ter no máximo 100 caracteres."),
        tipoVidro: Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable()
          .required(message),
        espessura: Yup.string().required(message),
        peso: Yup.string().required(message),
        fatorlh: Yup.string().required(message),
        controleSolar: Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable()
          .required(message),
        bloqueioRuido: Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable()
          .required(message),
        arredondamento: Yup.object()
          .shape({
            label: Yup.string(),
            value: Yup.string(),
          })
          .nullable()
          .required(message),
      });
      await schema.validate(vidro, { abortEarly: false });

      vidro.id = pId;

      const {
        data: { id },
      } = await api.post("vidro", vidro);
      toast.success("A ação foi concluída.");
      history.push(`/produtos/${id}/${vidro.codigo.replace('/', '')}/vidro`);

      setReload((reload) => !reload);
    } catch (err) {
      toast.error(getSingleErrorMessage(err));
      formRefVidros.current?.setErrors(getValidationErrors(err));
    }
  };

  const submit = () => {
    setLoadingSave(true);
    setTimeout(() => {
      setLoadingSave(false);
    }, 500);
    formRefVidros.current?.submitForm();
  };

  return (
    (novo || material) && (
      <>
        <div className="card mt-3">
          <div className="card-body mb-2">
            <div className="row">
              <span className="col-auto">
                <BackButton />
              </span>
              <span className="col-auto ml-auto">
                <Button
                  className="mr-2"
                  onClick={() => handleNew()}
                  variant="white"
                  disabled={novo}
                >
                  Pré-visualização
                </Button>
              </span>
              <span className="col-auto">
                {loadingSave ? (
                  <Button variant="primary" disabled>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </Button>
                ) : (
                  <Button variant="white" onClick={submit}>
                    Salvar
                  </Button>
                )}
              </span>
            </div>
            <Form ref={formRefVidros} onSubmit={handleSubmit}>
              <Tabs
                defaultActiveKey="geral"
                onSelect={(tab: any) => setSelectedTab(tab)}
              >
                <Tab eventKey="geral" title="Geral">
                  <TabGeral
                    selectValues={selectValues}
                    setLogoLinha={setLogoLinha}
                    loadingValues={loadingValues}
                  />
                </Tab>
                <Tab
                  disabled={novo}
                  eventKey="outrasCaracteristicas"
                  title="Outras Características"
                >
                  <TabOutrasCaracteristicas
                    setTableData={setOutrasCaracteristica}
                    tableData={outrasCaracteristica}
                  />
                </Tab>
                <Tab
                  disabled={novo}
                  eventKey="produtoCor"
                  title="Produto / Cor"
                >
                  <TabProdutoCor
                    selectedTab={selectedTab}
                    setReloadCor={setReloadCor}
                  />
                </Tab>
                <Tab
                  disabled={novo}
                  eventKey="imagensFichaTecnica"
                  title="Imagens / Ficha Técnica"
                >
                  <TabImagensFichaTecnica
                    setFiguraIcone={setFiguraIcone}
                    figuraIcone={figuraIcone}
                  />
                </Tab>
              </Tabs>
            </Form>
          </div>
        </div>

        {/* Modal Pré-visualização */}
        <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Pré-visualização</Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-3 pb-3">
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-sm-6 col-lg-6 pl-0">
                    <div className="card card-sm">
                      <a className="d-block">
                        <Image
                          src={
                            figuraIcone.nomeImagem != null
                              ? baseUrlImagem +
                                emValidacao.current +
                                figuraIcone.nomeImagem
                              : Placeholder
                          }
                          onError={(e: any) => {
                            e.target.src = Placeholder;
                          }}
                          className="card-img-top"
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-sm-6 pr-0">
                    <div className="card-body pb-0">
                      <div className="d-flex align-items-center">
                        <div>
                          {logoLinha && (
                            <Image
                              src={URL.createObjectURL(base64toBlob(logoLinha))}
                              onError={(e: any) => {
                                e.target.src = Placeholder;
                              }}
                              width="180px"
                              className="pb-4"
                            />
                          )}
                          <div className="font-weight-bold">
                            {material?.codigo}
                          </div>
                          <div>{material?.descricao}</div>
                          <div className="row text-muted mt-3">
                            <div className="col-sm-12 pb-3">
                              <Button
                                className="btn btn-mof btn-sm"
                                onClick={(e) => {
                                  e.preventDefault();
                                  window.open(
                                    material?.linkDesenhoTecnico,
                                    "_blank"
                                  );
                                }}
                              >
                                FICHA TÉCNICA
                                <i className="far fa-file-pdf pl-3"></i>
                              </Button>
                            </div>
                            <div className="col-sm-12">
                              <div className="row">
                                <div className="col-sm-12">
                                  <span className="font-weight-bold">
                                    Tipo de vidro:
                                  </span>
                                  <span className="ml-1">
                                    {material?.tipoVidro.label}
                                  </span>
                                </div>
                                <div className="col-sm-12">
                                  <span className="font-weight-bold">
                                    Espessura:
                                  </span>
                                  <span className="ml-1">
                                    {material?.espessura} mm
                                  </span>
                                </div>
                                <div className="col-sm-12">
                                  <span className="font-weight-bold">Cor:</span>
                                  <span className="ml-1">
                                    {corVidros.map(({ label }, index) => (
                                      <>{index != 0 ? `, ${label}` : label} </>
                                    ))}
                                  </span>
                                </div>
                                <div className="mt-3 col-sm-12">
                                  <span className="badge badge-xl bg-green-lt text-uppercase h4">
                                    {material?.situacao.label}
                                  </span>
                                  <span className="ml-1 badge badge-xl bg-azure-lt text-uppercase h4">
                                    {material?.status.label}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card row mt-3">
                  <div className="card-header">
                    <h3 className="card-title">OUTRAS CARACTERÍSTICAS:</h3>
                  </div>
                  <div className="card-body">
                    <div className="row text-muted">
                      <div className="col-sm-12">
                        <div className="row">
                          {outrasCaracteristica.map(
                            ({ nome, descricao }, index) => (
                              <div className="col-sm-6" key={index}>
                                <span className="font-weight-bold">
                                  {nome}:
                                </span>{" "}
                                {descricao}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    )
  );
};
export default Vidros;
